// Mirrors php/Legacy/Orders/EpmsOrderLineInfo.php's TYPE_* constants.
export const ORDER_LINE_TYPE = {
    PRODUCT: 0,
    ADDED_COST: 1,
    DISCOUNT: 2,
    DELIVERY: 3,
    TOTAL: 4,
    VAT: 5,
};
